export const STATUS_ORDER = ["Firma", "Servis", "Plasiyer", "Depo", "Üretim"];

const STATUS_LOCATIVE = {
  Firma: "Firmada",
  Servis: "Serviste",
  Plasiyer: "Plasiyerde",
  Depo: "Depoda",
  Üretim: "Üretimde",
};

const STATUS_COLOR_CLASSES = {
  Firma: { bg: "bg-indigo-100", text: "text-indigo-700" },
  Servis: { bg: "bg-amber-100", text: "text-amber-700" },
  Plasiyer: { bg: "bg-blue-100", text: "text-blue-700" },
  Depo: { bg: "bg-emerald-100", text: "text-emerald-700" },
  Üretim: { bg: "bg-purple-100", text: "text-purple-700" },
};

const NEUTRAL_COLOR_CLASSES = { bg: "bg-gray-100", text: "text-gray-700" };

export const getStatusLocative = (status) => {
  if (status == null) return "-";
  return STATUS_LOCATIVE[status] || status;
};

export const getStatusColorClasses = (status) => {
  return STATUS_COLOR_CLASSES[status] || NEUTRAL_COLOR_CLASSES;
};

export const sortStatuses = (statuses) => {
  return [...statuses].sort((a, b) => {
    const ai = STATUS_ORDER.indexOf(a);
    const bi = STATUS_ORDER.indexOf(b);
    if (ai !== -1 && bi !== -1) return ai - bi;
    if (ai !== -1) return -1;
    if (bi !== -1) return 1;
    return a.localeCompare(b, "tr");
  });
};
